// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PublishBidPackagePageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type PublishBidPackagePageQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, name: string, dueDate?: Types.Scalars['Date']['input'] | null | undefined, estimatedAwardDate?: Types.Scalars['Date']['input'] | null | undefined, estimatedConstructionDate?: Types.Scalars['Date']['input'] | null | undefined, existingInvitationText?: string | null | undefined, invitationText?: string | null | undefined, bidInstructionsText?: string | null | undefined, versionNotes?: string | null | undefined, planRoomLink?: string | null | undefined, isUnitBased: boolean, scopeHasChanged: boolean, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, activeRequests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, lastVersion?: { __typename?: 'BidPackageVersion', id: string } | null | undefined }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, requests: Array<{ __typename?: 'BidPackageVersionRequest', id: string, notify: boolean, bidPackageRequest: { __typename?: 'BidPackageRequest', id: string } }> } } };

export type SaveBidPackageMutationVariables = Types.Exact<{
  input: Types.SaveBidPackageInput;
}>;


export type SaveBidPackageMutation = { __typename?: 'Mutation', saveBidPackage: { __typename?: 'SaveBidPackageResult', bidPackage: { __typename?: 'BidPackage', id: string, name: string, dueDate?: Types.Scalars['Date']['input'] | null | undefined, estimatedAwardDate?: Types.Scalars['Date']['input'] | null | undefined, estimatedConstructionDate?: Types.Scalars['Date']['input'] | null | undefined, existingInvitationText?: string | null | undefined, invitationText?: string | null | undefined, bidInstructionsText?: string | null | undefined, versionNotes?: string | null | undefined, planRoomLink?: string | null | undefined, isUnitBased: boolean, scopeHasChanged: boolean, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, activeRequests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, lastVersion?: { __typename?: 'BidPackageVersion', id: string } | null | undefined }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, requests: Array<{ __typename?: 'BidPackageVersionRequest', id: string, notify: boolean, bidPackageRequest: { __typename?: 'BidPackageRequest', id: string } }> } } } };

export type PublishBidPackagePage_BidPackageFragment = { __typename?: 'BidPackage', id: string, name: string, dueDate?: Types.Scalars['Date']['input'] | null | undefined, estimatedAwardDate?: Types.Scalars['Date']['input'] | null | undefined, estimatedConstructionDate?: Types.Scalars['Date']['input'] | null | undefined, existingInvitationText?: string | null | undefined, invitationText?: string | null | undefined, bidInstructionsText?: string | null | undefined, versionNotes?: string | null | undefined, planRoomLink?: string | null | undefined, isUnitBased: boolean, scopeHasChanged: boolean, projects: Array<{ __typename?: 'StandaloneProject', id: string, name: string } | { __typename?: 'Region', id: string, name: string } | { __typename?: 'Market', id: string, name: string } | { __typename?: 'Community', id: string, name: string } | { __typename?: 'Subdivision', id: string, name: string } | { __typename?: 'Lot', id: string, name: string } | { __typename?: 'Structure', id: string, name: string } | { __typename?: 'Unit', id: string, name: string }>, activeRequests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, lastVersion?: { __typename?: 'BidPackageVersion', id: string } | null | undefined }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, requests: Array<{ __typename?: 'BidPackageVersionRequest', id: string, notify: boolean, bidPackageRequest: { __typename?: 'BidPackageRequest', id: string } }> } };

export type PublishBidPackagePage_ActiveRequestFragment = { __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string }, lastVersion?: { __typename?: 'BidPackageVersion', id: string } | null | undefined };

export const PublishBidPackagePage_ActiveRequestFragmentDoc = gql`
    fragment PublishBidPackagePage_ActiveRequest on BidPackageRequest {
  id
  tradePartner {
    ...Named
  }
  lastVersion {
    id
  }
}
    ${NamedFragmentDoc}`;
export const PublishBidPackagePage_BidPackageFragmentDoc = gql`
    fragment PublishBidPackagePage_BidPackage on BidPackage {
  id
  name
  dueDate
  estimatedAwardDate
  estimatedConstructionDate
  existingInvitationText
  invitationText
  bidInstructionsText
  versionNotes
  planRoomLink
  isUnitBased
  projects {
    ...Named
  }
  activeRequests {
    ...PublishBidPackagePage_ActiveRequest
  }
  latestVersion {
    id
    requests {
      id
      bidPackageRequest {
        id
      }
      notify
    }
  }
  scopeHasChanged
}
    ${NamedFragmentDoc}
${PublishBidPackagePage_ActiveRequestFragmentDoc}`;
export const PublishBidPackagePageDocument = gql`
    query PublishBidPackagePage($id: ID!) {
  bidPackage(id: $id) {
    ...PublishBidPackagePage_BidPackage
  }
}
    ${PublishBidPackagePage_BidPackageFragmentDoc}`;

/**
 * __usePublishBidPackagePageQuery__
 *
 * To run a query within a React component, call `usePublishBidPackagePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishBidPackagePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishBidPackagePageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishBidPackagePageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables> & ({ variables: PublishBidPackagePageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>(PublishBidPackagePageDocument, options);
      }
export function usePublishBidPackagePageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>(PublishBidPackagePageDocument, options);
        }
// @ts-ignore
export function usePublishBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>;
export function usePublishBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PublishBidPackagePageQuery | undefined, PublishBidPackagePageQueryVariables>;
export function usePublishBidPackagePageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>(PublishBidPackagePageDocument, options);
        }
export type PublishBidPackagePageQueryHookResult = ReturnType<typeof usePublishBidPackagePageQuery>;
export type PublishBidPackagePageLazyQueryHookResult = ReturnType<typeof usePublishBidPackagePageLazyQuery>;
export type PublishBidPackagePageSuspenseQueryHookResult = ReturnType<typeof usePublishBidPackagePageSuspenseQuery>;
export type PublishBidPackagePageQueryResult = Apollo.QueryResult<PublishBidPackagePageQuery, PublishBidPackagePageQueryVariables>;
export const SaveBidPackageDocument = gql`
    mutation SaveBidPackage($input: SaveBidPackageInput!) {
  saveBidPackage(input: $input) {
    bidPackage {
      ...PublishBidPackagePage_BidPackage
    }
  }
}
    ${PublishBidPackagePage_BidPackageFragmentDoc}`;
export type SaveBidPackageMutationFn = Apollo.MutationFunction<SaveBidPackageMutation, SaveBidPackageMutationVariables>;

/**
 * __useSaveBidPackageMutation__
 *
 * To run a mutation, you first call `useSaveBidPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBidPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBidPackageMutation, { data, loading, error }] = useSaveBidPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBidPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBidPackageMutation, SaveBidPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBidPackageMutation, SaveBidPackageMutationVariables>(SaveBidPackageDocument, options);
      }
export type SaveBidPackageMutationHookResult = ReturnType<typeof useSaveBidPackageMutation>;
export type SaveBidPackageMutationResult = Apollo.MutationResult<SaveBidPackageMutation>;
export type SaveBidPackageMutationOptions = Apollo.BaseMutationOptions<SaveBidPackageMutation, SaveBidPackageMutationVariables>;